import React, { useRef, useEffect } from 'react';

const TrustBox = ({ content }) => {
	const ref = useRef(null);
	const matches = content.templateCode.match(/\b(data-[a-z-]+="[^"]*)/g).reduce((acc, match) => {
		const [key, value] = match.split('="');
		return ({ ...acc, [key]: value });
	}, {});

	if (/<!--.*hidden.*-->/i.test(content.templateCode)) matches.style = { ...(matches.style || {}), display: 'none' };

	useEffect(() => {
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(ref.current, true);
		}
	}, []);

	return (
		<div ref={ref} className="trustpilot-widget" {...matches}>
			<a href="https://www.trustpilot.com/review/marsblade.com" target="_blank" rel="noopener noreferrer">Trustpilot</a>
		</div>
	);
};

export default TrustBox;
